import { render, staticRenderFns } from "./user_grzx.vue?vue&type=template&id=65bf1232&scoped=true"
import script from "./user_grzx.vue?vue&type=script&lang=js"
export * from "./user_grzx.vue?vue&type=script&lang=js"
import style0 from "./user_grzx.vue?vue&type=style&index=0&id=65bf1232&prod&scoped=true&lang=less"
import style1 from "./user_grzx.vue?vue&type=style&index=1&id=65bf1232&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf1232",
  null
  
)

export default component.exports